import { FC, useState } from "react";

import { Restricted } from "../../../../../../components/Restricted";
import { NamedRow } from "../../../../../../components/GeneralUI/NamedRow/NamedRow";
import { EditFieldSlideOver } from "./EditFieldSlideOver";
import { capitalizeAssociatedPress } from "../../../../../../helpers/string/capitalize";
import {
  NumbericOnlyProps,
  SelectOptionsProps,
} from "../../../../molecules/types";
import { Acceptable } from "../../../../../../helpers/functions/types";

type FieldNamedRowProps = Acceptable<any> &
  NumbericOnlyProps & {
    namedRowTitle: string;
    slideOverValue?: string | number;
    inputType?: React.HTMLInputTypeAttribute;
    slideOverInfo?: string;
    permissionsGroup: string;
    options?: SelectOptionsProps;
    customContent?: string;
    capitalize?: boolean;
  };

export const SlideOverFieldNamedRow: FC<
  React.PropsWithChildren<FieldNamedRowProps>
> = ({
  namedRowTitle,
  slideOverValue,
  inputType,
  slideOverInfo,
  onAccept,
  permissionsGroup,
  options,
  customContent,
  ...rest
}) => {
  const [openEditSlideOver, setOpenEditSlideOver] = useState(false);
  const required = !!options
    ? !options?.some((option) =>
        typeof option === "string" ? !option.length : !option.value,
      )
    : true;

  return (
    <Restricted permissions={`${permissionsGroup}:view`}>
      <NamedRow
        title={capitalizeAssociatedPress(namedRowTitle)}
        content={customContent ?? slideOverValue}
        isLoading={slideOverValue === undefined}
        editPermissions={`${permissionsGroup}:update`}
        onClick={() => setOpenEditSlideOver(true)}
      />

      <EditFieldSlideOver
        {...rest}
        type={inputType}
        title={capitalizeAssociatedPress(namedRowTitle)}
        value={slideOverValue}
        open={openEditSlideOver}
        onAccept={onAccept}
        onClose={() => setOpenEditSlideOver(false)}
        slideOverInfo={slideOverInfo}
        options={options}
        required={required}
      />
    </Restricted>
  );
};
